import { useState, useEffect } from "react";
import UserController from "../services/user-controller";
import { emit, setToken, sleep } from "../utility";
import { useNavigate } from "react-router-dom";

export default function Redirect(props) {
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const navigate = useNavigate();
	//
	const userController = new UserController();

	useEffect(() => {
		getData();
	}, []);

	const getData = async function () {
		try {
			setIsLoading(true);
			setErrorMessage("");
			const queryParams = new URLSearchParams(
				window.location.href.split("?")[1]
			);
			var redirectResult = await userController.checkRedirect(
				queryParams.get("ticket")
			);
			if (redirectResult.isSuccess === false) throw redirectResult.message;
			//
			setToken(redirectResult.value);
			localStorage.setItem("isRedirected", true);
			await sleep(1000);
			emit("refreshProfile", "");
			window.location.href = "/#/" + queryParams.get("page") ;
		} catch (error) {
			setErrorMessage(error.toString());
		}

		setIsLoading(false);
	};

	return (
		<>
			{isLoading === true && <h2>لطفا منتظر بمانید...</h2>}
			{isLoading === false && <h2>{errorMessage}</h2>}
		</>
	);
}
